import { Roles } from 'utils/constants';

const currencyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

export const getTotalProductNum = (arr) =>
  arr.reduce((prev, curr) => prev + curr.quantity, 0);

export const getTotalAmount = (arr) =>
  currencyFormatter.format(
    arr.reduce((prev, curr) => prev + curr.quantity * curr.current_price, 0)
  );

export const getProductName = (product, locale) =>
  product?.description_map?.[locale] ||
  product?.description_map?.it ||
  product?.description ||
  '';

export const getProductDescription = (product, locale) =>
  product?.kind_description_map?.[locale] ||
  product?.kind_description_map?.it ||
  product?.kind_description ||
  '';

export const parseDevelonProducts = ({
  tickets,
  loggedUser,
  locale,
  needUnparsedTicket = false,
}) => {
  let parsedTickets = [];
  tickets
    .map((ticket) => {
      const id = ticket.id;
      const itemId = ticket.item_id;
      const ownerSnap = ticket.owner_snap;
      const isMerch = !ticket.product?.capacity;
      const isAccount =
        !isMerch &&
        loggedUser.email === ownerSnap.email &&
        loggedUser.givenName === ownerSnap.firstname &&
        loggedUser.familyName === ownerSnap.lastname;
      const owner = isMerch
        ? `${loggedUser.givenName} ${loggedUser.familyName}`
        : `${ownerSnap.firstname} ${ownerSnap.lastname}`;
      const description = getProductName(ticket.product, locale);
      const currencyFormatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      });
      const price = currencyFormatter.format(ticket.amount);
      const dates = ticket.reservation_snap?.reservation_dates?.length
        ? ticket.reservation_snap.reservation_dates
        : '';
      return {
        id,
        itemId,
        isAccount,
        isMerch,
        owner,
        description,
        price,
        quantity: 1,
        dates,
        role:
          (isMerch && loggedUser.type === Roles.OPERATOR) ||
          (ownerSnap &&
            ownerSnap.sdm_operator_type &&
            ownerSnap.sdm_operator_type !== 'prv')
            ? 'operator'
            : 'generalPublic',
        ...(needUnparsedTicket && {
          unparsedTicket: ticket,
        }),
      };
    })
    .map((pt) => {
      // const alreadyInArray = parsedTickets?.length
      //   ? parsedTickets.find((t) => t.itemId === pt.itemId)
      //   : null;
      // if (alreadyInArray)
      //   parsedTickets = [
      //     ...parsedTickets.filter((t) => t.itemId !== alreadyInArray.itemId),
      //     { ...alreadyInArray, quantity: alreadyInArray.quantity + 1 },
      //   ];
      // else parsedTickets.push(pt);
      parsedTickets.push(pt);
    });
  return parsedTickets;
};

const locales = {
  it: 'it-IT',
  en: 'en-US',
};

export const upperCase = (str) =>
  str[0].toUpperCase() + str.slice(1).toLowerCase();

export const formatDates = ({ array, locale }) => {
  const formattedDates = array.map((s) => {
    const dateFormatted = s?.reservation_start_date_time
      ? s?.reservation_start_date_time
          .replace(' ', 'T')
          .replace('00:00:00', '12:00:00')
      : s.date;
    const date = new Date(dateFormatted || s?.date);
    const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
    const stringDate = date.toLocaleString(locales[locale], options);
    const splitted = stringDate.split(' ');
    const capitalizedMonth =
      locale === 'en' ? upperCase(splitted[0]) : upperCase(splitted[1]);
    return {
      value: s.date,
      label: `${splitted[locale === 'en' ? 1 : 0]} ${capitalizedMonth}`,
    };
  });
  return formattedDates;
};
export const translateDate = ({ datesArray, locale }) => {
  const formattedDates = formatDates({ array: datesArray, locale });
  const days = formattedDates.map((d) => d.label.split(' ')[0]).join('/');
  const month = formattedDates[0].label.split(' ')[1];
  return locale === 'en' ? `${month} ${days}` : `${days} ${month}`;
};

export const MappingAzureUser = {
  firstname: 'firstname',
  lastname: 'lastname',
  personEmail: 'email',
  personPhone: 'phone',
  personMailingCountry: 'country',
  // personMailingCity: 'city',
  ragioneSociale: 'company',
  tipologia: 'sdm_operator_type',
  sottoTipologia: 'sdm_operator_sub_type',
  role: 'sdm_role_in_company',
};

export const MappingAzureOperatorType = {
  adp: 'adp',
  apa: 'apa',
  ret: 'ret',
  acq: 'acq',
  grs: 'grs',
  frn: 'frn',
  agn: 'agn',
  prd: 'prd',
  mrk: 'mrk',
  prv: 'prv',
  // prv: 'Privato',
  // adp: 'A&D Professionals',
  // apa: 'Contractor',
  // grs: 'Distributore',
  // frn: 'Fornitore',
  // agn: 'Agente',
  // acq: 'Buyer',
  // ret: 'Rivenditore',
};

export const MappingAzureSubOperatorType = {
  adp: {
    adp_arc: 'adp_arc',
    adp_dsn: 'adp_dsn',
    adp_in: 'adp_in',
    adp_lig: 'adp_lig',
    adp_geo: 'adp_geo',
    adp_oth: 'adp_oth',
  },
  apa: {
    apa_gnc: 'apa_gnc',
    apa_svl: 'apa_svl',
    apa_dds: 'apa_dds',
    apa_oth: 'apa_oth',
  },
  ret: {
    ret_bou: 'ret_bou',
    ret_cat: 'ret_cat',
    ret_dep: 'ret_dep',
    ret_gac: 'ret_gac',
    ret_oth: 'ret_oth',
  },
  frn: {
    frn_fdm: 'frn_fdm',
    frn_fdc: 'frn_fdc',
    frn_fds: 'frn_fds',
  },
  grs: {
    grs_dsr: 'grs_dsr',
    grs_imp: 'grs_imp',
    grs_exp: 'grs_exp',
    grs_oth: 'grs_oth',
  },
  prd: {
    prd_ard: 'prd_ard',
    prd_aru: 'prd_aru',
    prd_arb: 'prd_arb',
    prd_cda: 'prd_cda',
    prd_arc: 'prd_arc',
    prd_ele: 'prd_ele',
    prd_lig: 'prd_lig',
    prd_oth: 'prd_oth',
  },
  acq: {
    acq_sdb: 'acq_sdb',
    acq_ret: 'acq_ret',
    acq_who: 'acq_who',
    acq_dps: 'acq_dps',
    acq_gda: 'acq_gda',
    acq_oth: 'acq_oth',
  },
  // adp: {
  //   adp_arc: 'Architetto',
  //   adp_dsn: 'Designer',
  //   adp_in: "Decoratore d'interni",
  //   adp_lig: 'Lighting designer',
  //   adp_geo: 'Geometra',
  //   adp_oth: 'Altro',
  // },
  // apa: {
  //   apa_gnc: 'General Contractor',
  //   apa_svl: 'Real Estate & Developer',
  //   apa_dds: 'Facility Manager',
  //   apa_oth: 'Altro',
  // },
  // frn: {
  //   frn_fdm: 'Fornitore di materiali',
  //   frn_fdc: 'Fornitore di componenti',
  //   frn_fds: 'Fornitore di servizi',
  // },
  // grs: {
  //   grs_dsr: 'Distributore',
  //   grs_imp: 'Importatore',
  //   grs_exp: 'Esportatore',
  //   grs_oth: 'Altro',
  // },
};

export const formatUTCDate = ({ date, locale }) => {
  const nDate = new Date(date);
  const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
  const stringDate = nDate.toLocaleString(locales[locale], options);
  const splitted = stringDate.split(' ');
  // This transform april in apr
  const month =
    locale === 'en'
      ? `${splitted[0][0].toLowerCase()}${splitted[0][1]}${splitted[0][2]}`
      : `${splitted[1][0]}${splitted[1][1]}${splitted[1][2]}`;
  return `${splitted[locale === 'en' ? 1 : 0]} ${month}`;
};

export const MAX_CART_ITEM_AMOUNT = 15;
export const IS_MERCH_COUNT_IN_TOT = false;
